package ai.flowstorm.common.ui

abstract class PagePanel : RootPanel() {
    init {
        navbar.add(usernav)
    }
}